import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Mail, Copy, Check, Inbox } from "lucide-react";
import { toast } from "sonner";

export default function ForwardEmailCard() {
  const [inbox, setInbox] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/inbox").then((r) => setInbox(r.data)).catch(() => {});
  }, []);

  const copy = async () => {
    if (!inbox?.forwarding_address) return;
    try {
      await navigator.clipboard.writeText(inbox.forwarding_address);
      setCopied(true);
      toast.success("Address copied");
      setTimeout(() => setCopied(false), 1800);
    } catch { toast.error("Copy failed"); }
  };

  if (!inbox) return null;

  return (
    <div data-testid="forward-email-card" className="rounded-2xl border border-border bg-card p-6">
      <div className="flex items-start gap-4">
        <div className="h-11 w-11 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
          <Mail className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-heading font-bold text-lg leading-tight">Forward receipts by email</p>
          <p className="text-sm text-muted-foreground mt-1 mb-4">
            Forward any email receipt to your private address and we'll auto-import & categorize it.
            {inbox.imported_count > 0 && (
              <span className="inline-flex items-center gap-1 ml-1 text-primary font-medium">
                <Inbox className="h-3.5 w-3.5" /> {inbox.imported_count} imported
              </span>
            )}
          </p>
          <div className="flex flex-col sm:flex-row gap-2">
            <code data-testid="forwarding-address" className="flex-1 truncate text-sm font-mono bg-secondary/60 border border-border rounded-xl px-4 py-2.5">
              {inbox.forwarding_address}
            </code>
            <Button data-testid="copy-address-button" onClick={copy} variant="outline" className="rounded-xl shrink-0">
              {copied ? <Check className="h-4 w-4 mr-2 text-green-600" /> : <Copy className="h-4 w-4 mr-2" />}
              {copied ? "Copied" : "Copy"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
